import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=69549ae2&scoped=true"
import script from "@/views/Products/Product.ts?vue&type=script&lang=ts&external"
export * from "@/views/Products/Product.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Products/Product.scss?vue&type=style&index=0&id=69549ae2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69549ae2",
  null
  
)

export default component.exports